export default "__VITE_ASSET__rfn473pN__"